import React from 'react';
import { Result, Button } from 'antd';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console or error reporting service
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // User-friendly Turkish fallback (F-03)
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <Result
            status="500"
            title="500"
            subTitle="Beklenmeyen bir hata oluştu. Lütfen sayfayı yenileyin."
            extra={
              <div className="space-x-2">
                <Button
                  type="primary"
                  onClick={() => window.location.reload()}
                >
                  Sayfayı Yenile
                </Button>
                <Button onClick={() => window.history.back()}>
                  Geri Dön
                </Button>
              </div>
            }
          />
        </div>
      );
    }

    return this.props.children;
  }
}

/** Error boundary for the map only — prevents map failures (e.g. AuthFailure) from crashing the CMS. Shows Turkish fallback. */
class MapErrorBoundaryClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Map ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="h-full min-h-[500px] flex items-center justify-center bg-gray-100 rounded-lg border border-gray-200"
          role="alert"
        >
          <div className="text-center px-4">
            <p className="text-gray-700 font-medium mb-1">
              Harita yüklenemedi.
            </p>
            <p className="text-gray-600 text-sm mb-4">
              Harita şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyin veya sayfayı yenileyin.
            </p>
            <Button type="primary" onClick={() => window.location.reload()}>
              Sayfayı Yenile
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const MapErrorBoundary = (props) => <MapErrorBoundaryClass {...props} />;

// Functional component wrapper for easier usage
const ErrorBoundaryWrapper = ({ children }) => {
  return <ErrorBoundary>{children}</ErrorBoundary>;
};

export default ErrorBoundaryWrapper;
export { MapErrorBoundary };
